import { render, staticRenderFns } from "./UserParams.vue?vue&type=template&id=057b1cd8&scoped=true&"
import script from "./UserParams.vue?vue&type=script&lang=js&"
export * from "./UserParams.vue?vue&type=script&lang=js&"
import style0 from "./UserParams.vue?vue&type=style&index=0&id=057b1cd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057b1cd8",
  null
  
)

export default component.exports